module.exports = __webpack_public_path__ + "img/About_item_3.cd5193a7.jpg";